(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll?.('.section-matchboox-home .mb40__hero-autoplay-video').forEach((video) => {
      if (video.dataset.mbAutoplayReady === 'true') return;
      video.dataset.mbAutoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = false;
      const visual = video.closest('.mb40__hero-visual');
      const image = visual?.querySelector('.mb40__hero-image');
      const firstFrame = visual?.querySelector('.mb40__hero-video-first-frame');
      let startFallbackTimer;
      let imageShownEarly = false;

      const hideFirstFrameAfterVideoPaint = () => {
        if (!firstFrame) return;
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(() => firstFrame.classList.add('is-hidden'));
        } else {
          window.requestAnimationFrame(() => firstFrame.classList.add('is-hidden'));
        }
      };

      const showImage = () => {
        window.clearTimeout(startFallbackTimer);
        video.classList.remove('is-playing');
        video.classList.add('is-finished');
        visual?.classList.add('is-video-finished');
        firstFrame?.classList.add('is-hidden');
        if (image) {
          image.style.opacity = '1';
          image.style.visibility = 'visible';
          image.removeAttribute('aria-hidden');
        }
      };

      const showImageOneSecondEarly = () => {
        if (imageShownEarly || !Number.isFinite(video.duration) || video.duration <= 1) return;
        if (video.duration - video.currentTime > 1) return;
        imageShownEarly = true;
        showImage();
      };

      const fallBackToImage = () => {
        video.pause();
        showImage();
      };

      video.addEventListener('playing', () => {
        window.clearTimeout(startFallbackTimer);
        visual?.classList.remove('is-video-finished');
        video.classList.remove('is-finished');
        video.classList.add('is-playing');
        imageShownEarly = false;
        hideFirstFrameAfterVideoPaint();
        if (image) {
          image.style.opacity = '0';
          image.style.visibility = 'hidden';
          image.setAttribute('aria-hidden', 'true');
        }
      });
      video.addEventListener('timeupdate', showImageOneSecondEarly);
      video.addEventListener('ended', showImage);
      video.addEventListener('error', fallBackToImage);
      video.addEventListener('abort', fallBackToImage);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        showImage();
        return;
      }

      video.currentTime = 0;
      startFallbackTimer = window.setTimeout(() => {
        if (video.paused || video.readyState < 2) fallBackToImage();
      }, 1800);
      const playPromise = video.play();
      if (playPromise?.catch) playPromise.catch(fallBackToImage);
      if (!video.paused && video.readyState >= 2) hideFirstFrameAfterVideoPaint();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));

  /* Desktop: houd het mediablok gecentreerd in de rechterkolom en lijn de onderzijde
     exact uit met de onderzijde van de twee actieknoppen. */
  const alignDesktopHeroMedia = () => {
    document.querySelectorAll('.section-matchboox-home .mb40__hero').forEach((hero) => {
      const media = hero.querySelector('.mb40__hero-media');
      const actions = hero.querySelector('.mb40__hero-actions');
      if (!media || !actions) return;
      media.style.transform = '';
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      const difference = actions.getBoundingClientRect().bottom - media.getBoundingClientRect().bottom;
      media.style.transform = `translateY(${difference.toFixed(2)}px)`;
    });
  };

  const scheduleHeroAlignment = () => window.requestAnimationFrame(() => window.requestAnimationFrame(alignDesktopHeroMedia));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleHeroAlignment);
  else scheduleHeroAlignment();
  window.addEventListener('load', scheduleHeroAlignment, { once: true });
  window.addEventListener('resize', scheduleHeroAlignment, { passive: true });
  document.addEventListener('shopify:section:load', scheduleHeroAlignment);
})();
